// extracted by mini-css-extract-plugin
export default {"container":"VJ-z","disabled":"WJ-z","termsCheckbox":"XJ-z","signUpButton":"YJ-z","enrollingSpinner":"ZJ-z","learnMoreButton":"_J-z","buttonRow":"aK-z"};